__turbopack_context__.v({
  "CheckBox": "CheckBox-module__MwSIbq__CheckBox",
  "checked": "CheckBox-module__MwSIbq__checked",
  "disabled": "CheckBox-module__MwSIbq__disabled",
  "icon": "CheckBox-module__MwSIbq__icon",
  "title": "CheckBox-module__MwSIbq__title",
});
